// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2LvgZ","label":"LabeledBox_label__1VZQn"};